import { db } from "../firebaseClient"
import { doc, collection, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore"

const VISITOR_ID_KEY = "nesolearn_visitor_id"

// Anonymous, persistent per-browser ID — not tied to auth, so it also counts
// visitors who never sign up. Generated once, reused on every future visit
// from the same browser.
export const getOrCreateVisitorId = () => {
  if (typeof window === "undefined") return null
  let id = window.localStorage.getItem(VISITOR_ID_KEY)
  if (!id) {
    id = `v_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`
    window.localStorage.setItem(VISITOR_ID_KEY, id)
  }
  return id
}

// Logs one page-view event against an org's public surface — catalog page,
// org profile, course preview, etc. Broader than productViewHelpers, which
// only fires on a specific course/product detail page.
export const logPageView = async ({ orgId, path }) => {
  if (!orgId) return { error: null }
  try {
    const visitorId = getOrCreateVisitorId()
    const ref = doc(collection(db, "pageViews"))
    await setDoc(ref, {
      orgId,
      visitorId,
      path: path || (typeof window !== "undefined" ? window.location.pathname : ""),
      createdAt: serverTimestamp(),
    })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listOrgPageViews = async (orgId) => {
  try {
    const ref = collection(db, "pageViews")
    const q = query(ref, where("orgId", "==", orgId))
    const snap = await getDocs(q)
    return { pageViews: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { pageViews: [], error }
  }
}